import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

import 'lenis/dist/lenis.css'

/**
 * Lenis smooth scrolling, kept in lockstep with GSAP:
 *  • ScrollTrigger re-reads positions on every Lenis scroll event.
 *  • Lenis is driven by GSAP's ticker so both share a single rAF loop;
 *    `lagSmoothing(0)` stops GSAP from pausing that loop after a frame
 *    hiccup, which would freeze scrolling entirely.
 *
 * Returns the Lenis instance, or null when reduced motion is preferred
 * (native instant scrolling is left untouched in that case).
 */
export function initSmoothScroll() {
    if (prefersReducedMotion()) return null

    const lenis = new Lenis()

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => lenis.raf(time * 1000))
    gsap.ticker.lagSmoothing(0)

    return lenis
}

/**
 * The legal modals scroll inside their own panel, which the page instance skips
 * (the modal carries data-lenis-prevent), so each panel gets its own Lenis on
 * the same ticker for the same eased wheel feel. A nested instance only honours
 * data-lenis-prevent between the event target and its own wrapper, so the
 * modal's opt-out doesn't block it.
 */
export function initModalSmoothScroll() {
    if (prefersReducedMotion()) return

    document.querySelectorAll('.modal__body').forEach((wrapper) => {
        const lenis = new Lenis({ wrapper, content: wrapper.firstElementChild })

        gsap.ticker.add((time) => lenis.raf(time * 1000))
    })
}

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
